
/*------英文语音包------*/
export const lang = {
    home: "首页",
    zks: "找科室",
    zys: "找医生", 
    bzzx: "帮助中心",
    grzx: "个人中心",
    zbch: "足不出户",
    zxspjz: "在线视频就诊",
    xzys: "选择医生",
    txwzxx: "填写问诊信息",
    zfghfy: "支付挂号费用",
    ddysjh: "等待医生叫号",
    wzjs: "问诊结束",
    ckyszd: "查看医生诊断",
    xzwzzs: "下载问诊助手",
    yjxz: "一键下载，快捷安装",
    azwc: "安装完成后，即可与医生视频沟通",
    twzx: "图文咨询",
    qbks: "全部科室",
    zkmz: "专科门诊",
    syzn: "使用指南",
    yugh: "预约挂号问题",
    jzxg: "就诊相关问题",
    zhxg: "账号相关问题",
    fwtk: "服务条款",
    qtwt: "其他问题",
    zmy: "找名医",
    wlmz: "网络门诊时间",
    sw: "上午",
    xw: "下午",
    ws: "晚上 ",
    jt: "今天",
    mt: "明天",
    zk: "展开",
    sq: "收起",
    kssx: "科室筛选",
    jzrq: "就诊日期",
    jzsd: "就诊时段",
    qb: "全部",
    yy: "预约",
    zjyy: "专家预约",
    yjz: "已就诊",
    ks: "科室",
    yishen: "医生", 
    zt: "状态",
    ghcg: "挂号成功",
    ksjhh: "开始叫号后，将会有短信通知，请保持手机畅通！",
    spwz: "视频问诊",
    dycsy: "第一次使用，请先下载“问诊助手”",
    yaz: "已安装的用户请到个人中心打开视频",
    dksp: "打开视频",
    ysjdksp: "用手机打开视频",
    jzr: "就诊人",
    jzxh:  "就诊序号",
    xb: "性别",
    nl: "年龄",
    sfzh: "身份证号",
    sjh: "手机号",
    yiyuan: "医院",
    jzkh: "就诊卡号",
    hzms: "患者描述",
    jws: "既往史",
    gms: "过敏史",
    twzl: "图文资料",
    jzys: "接诊医生",
    zs: "主诉",
    xbs: "现病史",
    zd: "诊断",
    zdbc: "诊断补充",
    clyj: "处理意见",
    jc: "检查",
    jy: "检验 ",
    qmy: "去买药",
    pj: "评价",
    tjpj:  "提交评价",
    qsrndysdpj: "请输入您对医生的评价",
    xingming: "姓名",
    jrzkmz: "今日专科门诊",
    mzsj: "门诊时间",
    xzsj: "选择时间",
    xzjzr: "选择就诊人",
    bqms: "病情描述",
    qsrbqms:"请输入病情描述",
    jibing: "疾病",
    fbsj: "发病时间",
    yfydyw: "已服用的药物",
    tpzl: "图片资料",
    hyd: "化验单",
    yxddzl: "影像单等资料最多10张",
    tjsq: "提交申请",
    ypqd: "药品清单",
    ypm: "药品名",
    sl: "数量",
    jzrgl: "就诊人管理",
    dysdpj:  "对医生的评价",
    pjxq: "评价详情",
    sy: "肾炎",
    dx: "癫痫",
    cz: "操作",
    qt: "其它",
    xz:  "选择",
    ywgm: "药物过敏",
    qms: "青霉素",
    tplkss: "头孢类抗生素",
    psfkds: "破伤风抗毒素",
    plky:  "普鲁卡因",
    dky: "地卡因",
    halyw:  "磺胺类药物",
    wssb1: "维生素B1",
    fypa:  "泛影葡胺",
    aspl: "阿司匹林",
    swgm: "食物过敏",
    mg: "芒果",
    nn: "牛奶",
    hx: "海鲜",
    sun: "笋",
    xg: "香菇",
    hg: "黄瓜",
    hf: "花粉",
    hq: "油漆",
    pm: "皮毛",
    hzp: "化妆品",
    jbs: "疾病史",
    xzb: "心脏病",
    crb: "传染病",
    fjh: "肺结核",
    bdxgy: "病毒性肝炎",
    xxcb: "血吸虫病",
    lb: "淋病",
    sss: "手术史",
    lnss: "颅脑手术",
    jbss: "颈部手术",
    xbss: "胸部手术",
    fbss: "腹部手术",
    bbss: "背部手术",
    szss: "四肢手术",
    gz: "骨折",
    tbws: "头部外伤",
    ss: "烧伤",
    jjss: "肌腱损伤",
    pfrzzss: "皮肤软组织损伤",
    dks: "刀砍伤",
    dcs: "刀刺伤",
    dqr:"待确认",
    wzmy:"问诊名医",
    qxznyjzdks:"请选择您要就诊的科室",
    qyynyjzdym:"请预约您要就诊的名医",
    symy:"所有名医",
    530:"5月30日",
    zwjj: "暂无简介",
    sc: "擅长",
    mzlb: "门诊列表",
    jzrlb: "就诊人列表",
    cfddlb: '处方订单列表',
    cfddjl: "处方订单记录",
    wzjl: "问诊记录",
    wtj: "未提交",
    dzf: "待支付",
    djz: "待就诊",
    yqx: "已取消",
    zfcs: "支付超时",
    sqtk: "申请退款",
    tytk: "同意退款",
    jjtk: "拒绝退款",
    tkcg: "退款成功",
    tksb: "退款失败",
    hzxm: "患者姓名",
    yyh: "预约号",
    zkxq: "展开详情",
    qmpdrs: "前面排队人数",
    cg20fzwzf: "超过20分钟未支付，将自动取消订单",
    scbl: "上传病历",
    fcmy: "非常满意",
    hh: "很好",
    hbc: "还不错",
    yb: "一般",
    dgj: "待改进",
    qqha: "亲切和蔼",
    nxxz: "耐心细致",
    jyff: "经验丰富",
    yssg: "医术深湛",
    ydgs: "医德高尚",
    zyjd: "专业解答",
    rzfz: "认真负责",
    hfjs: "回复及时",
    qxbtk: "取消并退款",
    qxzqxyy:"请选择取消原因",
    ddsjc: "等待时间长",
    spwflj: "视频无法连接",
    spzlc: "视频质量差",
    xcys: "选错医生",
    lsys: "临时有事",
    ycsj: "约错时间",
    qxsm: "取消说明",
    yyjztjr: "注：医院将在提交日起3个工作日内处理您的退款",
    ryyw: "如有疑问，可联系医院热线电话",
    smxzzshn: "扫描下载掌上河南省人民医院互联网医院APP，体验足不出户看医生",
    tjjzr: "添加就诊人",
    bs: "病史",
    qrtj: "确认添加",
    txxx: "填写信息",
    qxqmszz: "请详情描述症状",
    qz20fznwcfk: "请在20分钟内完成付款，超时将视其为自动放弃此次预约",
    zfcg: "支付成功",
    nysqcg: "您已申请成功，请耐心等待专家接诊",
    fhsqlb: "返回申请列表",
    zfswcg: "支付尚未成功",
    skf: "收款方",
    yfje: "应付金额",
    cxzf: "重新支付",
    qzxdkdymwczf: "请在新打开的页面完成支付",
    qwgb:"付款完成前请勿关闭此窗口",
    fkydwtqlxkf: "付款遇到问题请联系客服",
    fhxzqtzffs: "返回选择其他支付方式",
    fkcg: "付款成功",
    fkywt: "付款遇到问题",
    fkydwt: "付款遇到问题？",
    yebz: "余额不足（例：银行卡余额不足、信用卡透支额度超限、支付宝账户余额不足等）建议您换卡操作，若着急支付，建议您可找朋友代付",
    yhkedcx: "银行卡额度超限（单笔、日、月）",
    jynhk: "建议您换卡或其他支付方式操作",
    nxzxykkjzf: "您选择信用卡快捷支付，在支持的卖家购物，可进行大额支付",
    hcsdlzfb: "或尝试登录支付宝钱包，使用扫码支付, 若着急支付，建议您可找朋友代付",
    wlxtfm: "网络系统繁忙，建议稍后再试",
    wxdd:  "无效订单、重复支付请先前往【会诊中心】查看订单状态；若订单状态为【代付款】，则重新支付即可；若订单状态为【已申请】，则代表您已支付成功。",
    bcsm: "补充说明",
    tjtp: "添加图片",
    wxsm: "微信扫码 拍照上传",
    bdsc: "本地上传",
    xc: "哮喘",
    gxzz: "高血脂症",
    hnsxz: "高尿酸血症",
    gxy: "高血压",
    tnb: "糖尿病",
    ncz: "脑卒中",
    yuan:"元",
    xiugai:"修改",
    bc:"保存",
    jzlc:"就诊流程" ,
    qxyy:"取消原因" ,
    fy:"费用",
    qdyscm:"确定要删除么？" ,
    ts:"提示" ,
    nh:"你好" ,
    dl:"登录",
    zc:"注册",
    dlzc:"登录/注册" ,
    tc:"退出" ,
    qxxmszz:"请详细描述症状、疾病、发病时间、已服用的药物。。。。。。" ,
    qd:"确定" ,
    qx:"取消" ,
    bcg500:"不超过500个汉字"  ,
    tz:"停诊" ,
    gystz:"该医生已停诊，无法挂号"   ,
    gyswpb:"该医生暂无排班，无法挂号",
    zfy:"总费用"    ,
    qxzzffs:"请选择支付方式"  ,
    zfbzf:"支付宝支付"  ,
    wxzf:"微信支付"   ,
    nycstjnr:"您已超时提交内容，请重新挂号"    ,
    yzmdl:"验证码登录"   ,
    qsrxm:"请输入姓名",
    qsrsfzh:"请输入身份证号",
    qsrsjh:"请输入手机号"   ,
    qsryzm:"请输入验证码",
    qsrdxyzm:"请输入短信验证码"  ,
    hqyzm:"获取验证码"   ,
    qsrzqdsjh:"请输入正确的手机号"   ,
    dlcg:"登录成功",
    nywczf:"您已完成支付" ,
    qgbzfck:"请关闭支付窗口并返回原页面查看"  ,
    gbck:"关闭窗口"  ,
    dksjzfb:"打开手机支付宝"   ,
    sysjxfk:"扫一扫继续付款"   ,
    dkwxsys:"打开微信“扫一扫”完成支付"  ,
    djgbck:"点击关闭窗口继续会诊"   ,
    nyzfcs:"您已支付超时，请重新申请"   ,
    zfsb:"支付失败"   ,
    xszf:"线上支付" ,
    ygh:"已过号"  ,
    dtj:"待提交" ,
    bj:"编辑"   ,
    shanchu:"删除"   ,
    qrscjzr:"确认删除就诊人",
    bltp:"病历图片" ,
    ckxq:"查看详情" ,
    ddh:"订单号"  ,
    qxzyy:"请选择原因"  ,
    ysjhs:"医生叫到号时，请保障正常通讯，可点击重新候诊进行再次等待叫号" ,
    tkz:"退款中" ,
    ddqrtk:"等待确认退款"  ,
    hzyqx:"会诊已取消，款项会原路退回到您的账户" ,
    cxhz:"重新候诊" ,
    bzcgwjlx:"不支持该文件类型上传"  ,
    yf:"用法",
    smewm:"微信扫描二维码",
    kstwzx:"开始图文咨询",
    wu:"无",
    zwpb:"暂无排班",
    dizhi:"地址",
    dizhi_value:"河南省郑州市金水区纬道7号五号（450040）",
    dianhua:"电话",
    dianhua_value:"紧急呼叫：031-655 80120   呼叫：037 1-655 800（交换机）",
    bqsy:"版权所有（C）",
    bqsy_value:" 河南省人民医院版权所有",
    jszc:"技术支持",
    lxyx:"联系邮箱",
    yyewmmc:"医院二维码名称",
    jszc_value:"杭州卓健信息科技有限公司",
    ygq:"已过期",
    qdqhyym:"确定切换语言吗?",
    tishi:"提示",
    qdlndzh:"请登录您的账号",
    zzqx: "正在取消",
    hlwyy: "互联网医院",
}



// WEBPACK FOOTER //
// ./src/assets/common/lang/cn.js